import { useMemo } from 'react';

import { useGetSpecializedAgentsList } from '@frontend/features/agents/hooks';

/** The Steward's stable agent_id (matches the seed + the published directory agent). */
export const STEWARD_AGENT_ID = 'stickyboard_steward';

/**
 * Resolves the Steward's per-instance UUID (the `{agentId}` segment the
 * execute / stream-execute endpoints expect) by finding the installed
 * specialized agent whose stable `agent_id` is `stickyboard_steward`.
 *
 * Returns `agentUuid: null` until the agents list loads or if the Steward
 * isn't installed for this instance — callers should gate on `ready`.
 */
export function useStewardAgent() {
  const { agents, isPending, error } = useGetSpecializedAgentsList();

  const agentUuid = useMemo(() => {
    const steward = agents.find(a => a.agent_id === STEWARD_AGENT_ID);
    return steward?.id ?? null;
  }, [agents]);

  return { agentUuid, ready: !!agentUuid, isPending, error };
}
